/** Multi-input logical XOR. */
export function xor(...args: unknown[]) {
  return args.reduce<number>((acc, arg) => acc + (arg ? 1 : 0), 0) === 1;
}